module.exports = __webpack_public_path__ + "img/diaceutics_logo_withstrap_navy.b0762b25.svg";